<template>
<!--品质检查标准审批-->
  <div style="width: 100%;padding-top: 60px">
    <div style="position: fixed;top: 0;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="品质检查标准" name="1">
        <van-field label="标准名称" v-model="inputForm.name" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="检查级别" v-model="inputForm.inspectionLevelIdName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="检查频次" v-model="inputForm.frequency" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="考核方式" v-model="inputForm.evaluationModeName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      </van-collapse-item>
      <van-collapse-item name="2" title="标准明细">
       <!--  标准明细表待定-->
       <div v-for="item in inputForm.moduleList" :key="item.id">
         <div class="m-form" ref="scrollContainer">
           <div class="title">检查模块: {{item.moduleName}}</div>
           <div v-for="(data, index) in item.inspectionItemList" :key="index" style="margin-bottom: 10px">
             <div class="m-row">
               <div class="m-row-text">检查类别</div>
               <div class="m-row-content large-content">{{data.inspectionItemName}}</div>
             </div>
             <div class="m-row">
               <div class="m-row-text">检查类别说明</div>
               <div class="m-row-content large-content">{{data.inspectionItemDescription}}</div>
             </div>
             <div class="m-row">
               <div class="m-row-text">分值比重</div>
               <div class="m-row-content large-content">{{data.scoreRatio}}%</div>
             </div>
             <div class="m-row">
               <div class="m-row-text">满分</div>
               <div class="m-row-content">{{data.fullScore}}</div>
             </div>
           </div>
         </div>
<!--         <h4>检查模块： {{item.moduleName}}</h4>-->
<!--         <div v-for="key in item.inspectionItemList" :key="key.id">-->
<!--            <div style="display: flex; justify-content: space-between">-->
<!--              <span>检查类别</span>-->
<!--              <span>{{key.inspectionItemName}}</span>-->
<!--            </div>-->
<!--           <div style="display: flex; justify-content: space-between">-->
<!--             <span>检查类别说明</span>-->
<!--             <span>{{key.inspectionItemDescription}}</span>-->
<!--           </div>-->
<!--           <div style="display: flex; justify-content: space-between" v-if="inputForm.scoreRatioStatus === '1'">-->
<!--             <span>分值比重</span>-->
<!--             <span>{{key.scoreRatio}}%</span>-->
<!--           </div>-->
<!--           <div style="display: flex; justify-content: space-between" v-if="inputForm.evaluationMode === '1'">-->
<!--             <span>满分</span>-->
<!--             <span>{{key.fullScore}}</span>-->
<!--           </div>-->
<!--         </div>-->

       </div>
      </van-collapse-item>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {queryById, startFlow} from '../../api/quality/QualityInspectionStandard'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "QualityInspectionStandard",
  data(){
    return {
      isshow: false,
      activeNames: ['1', '2'],
      inputForm: {
        id: '',
        name: '',
        inspectionLevelId: '',
        frequency: '',
        evaluationMode: '',
        scoreRatioStatus: '0',
        moduleList: [],
        isDoTask: false,
        isLastTask: false,
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      fields: [
        {key: 'inspectionItemName', label: '检查类别'},
        {key: 'inspectionItemDescription', label: '检查类别说明'},
        {key: 'scoreRatio', label: '分值比重'},
        {key: 'fullScore', label: '满分'},
      ],
      items: [],
    }
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  components: {
    processRecord
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      queryById(id).then(({data}) => {
        this.inputForm = data
        this.items = data.moduleList
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status === '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.plDeratedContent {
  height: calc(100vh - 60px);
  background-color: #fff!important;
}
.m-form {
  width: 100vw;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  background-color: #fff!important;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100vw - 22px);
  border: 1px solid #eee;
  /*border-bottom: 0px;*/
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #eee;*/
}

.m-row-content {
  width: calc(100vw - 130px);
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100vw - 130px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}

.textColor {
  color: #d9d8d8!important;
}
</style>
